import React from 'react';
import {InputGroup, InputGroupAddon} from 'reactstrap';

const MaybeInputGrouped = ({addons, children}) => {
  if (addons) {
    return (
      <InputGroup>
        {children}
        <InputGroupAddon addonType='append'>{addons}</InputGroupAddon>
      </InputGroup>
    );
  }

  return children;
};

export default MaybeInputGrouped;
